import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import React, { Component, isValidElement, cloneElement, createContext } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
var LayerContext = createContext(0);
/**
 * `Layer` component.
 */

var Layer =
/*#__PURE__*/
function (_Component) {
  _inherits(Layer, _Component);

  function Layer() {
    _classCallCheck(this, Layer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Layer).apply(this, arguments));
  }

  _createClass(Layer, [{
    key: "renderChildren",
    value: function renderChildren(_ref) {
      var children = _ref.children,
          level = _ref.level;
      var parentLevel = this.context;

      if (isValidElement(children)) {
        return cloneElement(children, {
          style: _objectSpread({}, children.props.style, {
            zIndex: parentLevel + level
          })
        });
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          children = _this$props.children,
          innerRef = _this$props.innerRef,
          level = _this$props.level,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "children", "innerRef", "level"]);

      var parentLevel = this.context;
      return createPortal(React.createElement(LayerContext.Provider, {
        value: parentLevel + level
      }, React.createElement("div", _extends({
        className: classNames(baseClassName, className),
        ref: innerRef
      }, props), this.renderChildren({
        children: children,
        level: level
      }))), document.body);
    }
  }]);

  return Layer;
}(Component);

Layer.propTypes = {
  /**
   * Content of the `Layer`.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string,

  /**
   * @ignore
   */
  innerRef: PropTypes.func,

  /**
   * Level.
   */
  level: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Layer.defaultProps = {
  children: null,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "layer"),
  innerRef: null,
  level: null
};
Layer.contextType = LayerContext;
export default Layer;